import { GameScene, SceneType, InputState } from '../types/game.types';

export class SceneManager {
  private scenes: Map<SceneType, GameScene> = new Map();
  private currentScene: GameScene | null = null;
  private currentSceneType: SceneType = SceneType.MENU;

  constructor() {
    // Scenes will be registered by the main application
  }

  public registerScene(type: SceneType, scene: GameScene): void {
    this.scenes.set(type, scene);
  }

  public switchScene(type: SceneType): void {
    // Cleanup current scene
    if (this.currentScene) {
      this.currentScene.cleanup();
    }

    // Get new scene
    const newScene = this.scenes.get(type);
    if (!newScene) {
      console.error(`Scene not found: ${type}`);
      return;
    }

    // Initialize new scene
    this.currentScene = newScene;
    this.currentSceneType = type;
    this.currentScene.init();

    console.log(`Switched to scene: ${type}`);
  }

  public getCurrentSceneType(): SceneType {
    return this.currentSceneType;
  }

  public update(deltaTime: number, inputState: InputState): void {
    if (this.currentScene) {
      this.currentScene.update(deltaTime, inputState);
      this.currentScene.handleInput(inputState);
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    if (this.currentScene) {
      this.currentScene.render(ctx);
    }
  }

  public cleanup(): void {
    if (this.currentScene) {
      this.currentScene.cleanup();
    }
    this.scenes.clear();
  }
}